import { fetch } from "../../../config/fetch.js";
import { PersoanalUserInfo, WriterInfoApi } from "../../../config/interface.js";

const SAVED_TIP_KEY = "expert_resume_saved_tip";
const CLOSED_TIP_KEY = "expert_resume_closed_tip";

function parseResumeTime(value) {
    if (value === undefined || value === null || value === "") {
        return null;
    }
    if (typeof value === "number" || /^\d+$/.test(String(value))) {
        const num = Number(value);
        if (!num) {
            return null;
        }
        return new Date(String(value).length <= 10 ? num * 1000 : num);
    }
    const date = new Date(String(value).replace(/-/g, "/"));
    return isNaN(date.getTime()) ? null : date;
}

export function formatResumeDeadline(value) {
    const date = parseResumeTime(value);
    if (!date) {
        return "";
    }
    const hour = date.getHours();
    const minute = date.getMinutes();
    const hh = hour < 10 ? "0" + hour : "" + hour;
    const mm = minute < 10 ? "0" + minute : "" + minute;
    return date.getFullYear() + "年" + (date.getMonth() + 1) + "月" + date.getDate() + "日" + hh + "：" + mm;
}

export function isResumeClosed(value) {
    const date = parseResumeTime(value);
    if (!date) {
        return false;
    }
    return Date.now() >= date.getTime();
}

export function markResumeClosedTip() {
    sessionStorage.setItem(CLOSED_TIP_KEY, "1");
}

export function consumeResumeClosedTip() {
    if (sessionStorage.getItem(CLOSED_TIP_KEY) === "1") {
        sessionStorage.removeItem(CLOSED_TIP_KEY);
        return true;
    }
    return false;
}

export function isLoggedIn(user) {
    if (!user || typeof user !== "object" || Array.isArray(user)) {
        return false;
    }
    if (user.mobile_status === 0 || user.mobile_status === "0") {
        return false;
    }
    return !!(user.mobile || user.mobile_status == 1);
}

function goLogin(vm) {
    vm.$router.replace({
        path: "/vascularNews/user/login",
        query: {
            meeting_id: vm.$route.query.meeting_id || vm.$route.query.id || vm.$route.query.MT_id,
            url: window.location.href
        }
    });
}

export function ensureLogin(vm) {
    const weixin = !!(window.common && window.common.is_weixin && window.common.is_weixin());
    const token = localStorage.getItem("token");
    const cached = vm.$store.state.userInfo;

    // 非微信端没有登录凭证时，先去登录，不展示简历
    if (!weixin && !token) {
        goLogin(vm);
        return Promise.resolve(null);
    }
    if (!weixin && isLoggedIn(cached)) {
        return Promise.resolve(cached);
    }

    return fetch(PersoanalUserInfo, {}, "POST").then((res) => {
        if (res && res.code == 602) {
            return null;
        }
        if (res && res.code == 0 && res.data) {
            localStorage.setItem("userInfo", JSON.stringify(res.data));
            vm.$store.dispatch("storageUserInfo", res.data);
            if (isLoggedIn(res.data)) {
                return res.data;
            }
            window.common.toast("未绑定手机", 1000, "fail", () => {
                goLogin(vm);
            });
            return null;
        }
        goLogin(vm);
        return null;
    }).catch(() => {
        goLogin(vm);
        return null;
    });
}

function mapWriter(data) {
    const writer = (data && data.writer) || {};
    const bound = data && (data.status === 1 || data.status === "1");
    return {
        ok: true,
        bound: !!bound,
        id: writer.id || "",
        name: writer.name || "",
        hospital: writer.company || "",
        intro: writer.des || "",
        photo: writer.photo || "",
        resume_end_time: writer.resume_end_time || ''
    };
}

// GET /meeting/writer/info?meeting_id=
export function fetchExpertResume(meetingId) {
    return fetch(WriterInfoApi(), { meeting_id: meetingId }, "GET").then((res) => {
        if (!res || res.code != 0 || !res.data) {
            return {
                ok: false,
                bound: false,
                message: (res && res.error_msg) || "获取简历失败"
            };
        }
        return mapWriter(res.data);
    }).catch(() => {
        return {
            ok: false,
            bound: false,
            message: "获取简历失败"
        };
    });
}

// PUT /meeting/writer/info?meeting_id=
export function submitExpertResume(meetingId, form) {
    const url = WriterInfoApi() + "?meeting_id=" + encodeURIComponent(meetingId || "");
    const params = {
        meeting_id: meetingId,
        name: (form.name || "").trim(),
        company: (form.hospital || "").trim(),
        des: (form.intro || "").trim(),
        photo: form.photo || ""
    };
    if (form.id) {
        params.id = form.id;
    }
    return fetch(url, params, "PUT").then((res) => {
        if (!res || res.code != 0) {
            return Promise.reject(res || { error_msg: "保存失败，请稍后重试" });
        }
        sessionStorage.setItem(SAVED_TIP_KEY, "1");
        return res;
    });
}

export function consumeSavedTip() {
    if (sessionStorage.getItem(SAVED_TIP_KEY) === "1") {
        sessionStorage.removeItem(SAVED_TIP_KEY);
        return true;
    }
    return false;
}



// WEBPACK FOOTER //
// ./src/pages/VascularSystem/Expert/resumeMock.js